import { responseId } from 'data/mock-data';

const mock = () => ({
  data: { responseID: responseId },
});

export default mock;
